import { useEffect } from 'react';

import useVccSeasonData from '../../../state/vccSeason/UseVccSeasonData';

const useVccSeasonDropdown = () => {
  const { vccSeasonState, getVccSeasons } = useVccSeasonData();

  useEffect(() => {
    if (vccSeasonState?.isArrayLoading !== true && vccSeasonState?.isArrayLoaded !== true) {
      getVccSeasons();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vccSeasonState]);
  return {
    vccSeasonState
  };
};

export default useVccSeasonDropdown;